import {useSelector} from "react-redux";

import {IRPStore} from "../../../../app/rp_reducer";
import {getRoomsFlatsLabelWhere} from "../../constants/prices_address_rooms";
import {RoomsFilter} from "../../constants/rcn_rooms_filter";
import {useRcnLatestStats} from "../../hooks/use_rcn_latest_stats";
import type {IPricesAddress} from "../../types/IPricesAddress";
import {getRcnPointTemporalCoverage} from "../../utils/format_rcn_period_label";

interface Props {
    address: IPricesAddress;
    rooms: RoomsFilter;
}

export const PricesAddressSchemaDataset = (props: Props) => {
    const {address, rooms} = props;

    const canonicalUrl = useSelector((state: IRPStore) => state.metaData.standardMetaData.canonical);
    const {point} = useRcnLatestStats(address.rcnAddress, rooms, "per_m2");

    if (!point) {
        return null;
    }

    const schema = {
        "@context": "https://schema.org",
        "@type": "Dataset",
        name: `Ceny transakcyjne mieszkań - ${address.name}, ${address.city.short_name}`,
        description: `Mediana ceny za m² ${getRoomsFlatsLabelWhere(rooms)} z aktów notarialnych (Rejestr Cen Nieruchomości) dla budynku ${address.name} ${address.city.name_declension_where}, rynek pierwotny i wtórny razem.`,
        url: canonicalUrl,
        license: "https://rynekpierwotny.pl/regulamin/",
        isAccessibleForFree: true,
        creator: {
            "@type": "Organization",
            name: "RynekPierwotny.pl",
            url: "https://rynekpierwotny.pl/"
        },
        isBasedOn: {
            "@type": "Dataset",
            name: "Rejestr Cen Nieruchomości",
            description: "Akty notarialne rejestrowane przez starostwa powiatowe"
        },
        spatialCoverage: {
            "@type": "Place",
            name: `${address.name}, ${address.city.short_name}`,
            geo: {
                "@type": "GeoCoordinates",
                latitude: address.lat,
                longitude: address.lng
            }
        },
        temporalCoverage: getRcnPointTemporalCoverage(point),
        variableMeasured: [
            {
                "@type": "PropertyValue",
                name: "Mediana ceny transakcyjnej za m²",
                value: Math.round(point.value),
                unitText: "PLN/m2"
            },
            {
                "@type": "PropertyValue",
                name: "Liczba transakcji",
                value: point.n_rows
            }
        ]
    };

    const json = JSON.stringify(schema).replace(/</g, "\\u003c");

    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: json}} />;
};
import {useSelector} from "react-redux";

import {IRPStore} from "../../../../app/rp_reducer";
import {getRoomsFlatsLabelWhere} from "../../constants/prices_address_rooms";
import {RoomsFilter} from "../../constants/rcn_rooms_filter";
import {useRcnLatestStats} from "../../hooks/use_rcn_latest_stats";
import type {IPricesAddress} from "../../types/IPricesAddress";
import {getRcnPointTemporalCoverage} from "../../utils/format_rcn_period_label";

interface Props {
    address: IPricesAddress;
    rooms: RoomsFilter;
}

export const PricesAddressSchemaDataset = (props: Props) => {
    const {address, rooms} = props;

    const canonicalUrl = useSelector((state: IRPStore) => state.metaData.standardMetaData.canonical);
    const {point} = useRcnLatestStats(address.rcnAddress, rooms, "per_m2");

    if (!point) {
        return null;
    }

    const schema = {
        "@context": "https://schema.org",
        "@type": "Dataset",
        name: `Ceny transakcyjne mieszkań - ${address.name}, ${address.city.short_name}`,
        description: `Mediana ceny za m² ${getRoomsFlatsLabelWhere(rooms)} z aktów notarialnych (Rejestr Cen Nieruchomości) dla budynku ${address.name} ${address.city.name_declension_where}, rynek pierwotny i wtórny razem.`,
        url: canonicalUrl,
        license: "https://rynekpierwotny.pl/regulamin/",
        isAccessibleForFree: true,
        creator: {
            "@type": "Organization",
            name: "RynekPierwotny.pl",
            url: "https://rynekpierwotny.pl/"
        },
        isBasedOn: {
            "@type": "Dataset",
            name: "Rejestr Cen Nieruchomości",
            description: "Akty notarialne rejestrowane przez starostwa powiatowe"
        },
        spatialCoverage: {
            "@type": "Place",
            name: `${address.name}, ${address.city.short_name}`,
            geo: {
                "@type": "GeoCoordinates",
                latitude: address.lat,
                longitude: address.lng
            }
        },
        temporalCoverage: getRcnPointTemporalCoverage(point),
        variableMeasured: [
            {
                "@type": "PropertyValue",
                name: "Mediana ceny transakcyjnej za m²",
                value: Math.round(point.value),
                unitText: "PLN/m2"
            },
            {
                "@type": "PropertyValue",
                name: "Liczba transakcji",
                value: point.n_rows
            }
        ]
    };

    const json = JSON.stringify(schema).replace(/</g, "\\u003c");

    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: json}} />;
};
